import { UccApi } from "./apis/ucc.api.ts";

// @ts-ignore
import './styles/styles.css';

// @ts-ignore
window.UCC = new UccApi(document.body);